<template>
  <div class="mobile-layout">
    <!-- 顶部栏 -->
    <div class="top-bar">
      <div class="top-title">橙姨母婴数据管理系统</div>
      <div class="top-icons">
        <i class="iconfont icon-notification" @mouseenter="showTip = true" @mouseleave="showTip = false"></i>
        <div class="tip" v-if="showTip">通知</div>
        <i class="iconfont icon-user"></i>
      </div>
    </div>

    <!-- 中间内容区域 -->
    <div class="content-wrapper">
      <router-view></router-view>
    </div>

    <!-- 底部栏 -->
    <div class="bottom-tab">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="tab-item"
        :class="{ active: currentPath === item.path }"
        @click="handleTabClick(item.path)"
      >
        <img :src="item.icon" alt="tab 图标" class="tab-icon" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { ref, watch } from 'vue';

const router = useRouter();
const route = useRoute();
// 存储当前完整路径
const currentPath = ref(route.path);
const showTip = ref(false);

// 底部 tab 配置（path 为绝对路径的部分，如 'home' 对应 '/mobile/home'）
const tabList = [
    { path: 'mine', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '数据管理' },
     { path: 'dingdan', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '订单管理' },
     { path: 'chat', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '绩效考核' },
     { path: 'talent', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '业务提升' },
     //{ path: 'interview', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '业务培训' },
     //{ path: 'mine', icon: new URL('@/assets/chengzi.png', import.meta.url).href, name: '我的' },
];

// 监听路由路径变化，更新 currentPath
watch(() => route.path, (newPath) => {
  currentPath.value = newPath;
});

// 处理 tab 点击，跳转到绝对路径
const handleTabClick = (path) => {
  // 拼接成绝对路径，如 path 是 'home'，则跳转 '/mobile/home'
  router.push(`/mobile/${path}`);
};
</script>

<style scoped>
/* 父组件样式 */
.mobile-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
  /* 关键：预留底部导航高度，防止内容被遮挡 */
  padding-bottom: 65px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* 顶部栏样式 */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(to right, #ff7f24, #ff5e00);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.top-title {
  font-size: 18px;
  font-weight: 600;
}

.top-icons {
  display: flex;
  gap: 20px;
  position: relative;
}

.top-icons i {
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s;
}

.top-icons i:hover {
  color: #ffd700;
}

.tip {
  position: absolute;
  top: 42px;
  right: 60px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 100;
}

/* 中间内容区域 */
.content-wrapper {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  /* 修复滚动条与内容的间距问题 */
  -webkit-overflow-scrolling: touch;
}

/* 底部导航栏 */
.bottom-tab {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0 12px; /* 调整底部内边距，避免图标被遮挡 */
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
  height: 65px; /* 固定高度，方便父容器预留空间 */
  box-sizing: border-box;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  padding-top: 5px;
}

.tab-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  object-fit: contain;
}

.tab-item span {
  font-size: 12px;
  color: #666;
}

/* 选中态样式 */
.tab-item.active .tab-icon {
  filter: hue-rotate(0deg) saturate(200%) brightness(100%);
}

.tab-item.active span {
  color: #ff7f24;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  display: block;
  width: 16px;
  height: 3px;
  background-color: #ff7f24;
  border-radius: 2px;
  margin-top: 4px;
}

</style>